import "@mui/material/styles";

/**
 * Custom theme extension for Charges Management module
 * Provides consistent colors and avoids hardcoded values
 */

// Extend MUI theme with custom palette
declare module "@mui/material/styles" {
  interface Palette {
    charges: {
      // Status colors
      status: {
        active: string;
        inactive: string;
        warning: string;
      };
      // Background colors
      backgrounds: {
        light: string;
        lighter: string;
        panel: string;
      };
      // Border colors
      borders: {
        light: string;
        medium: string;
        dark: string;
      };
      // Custom colors for charge types
      chargeTypes: {
        closed: string;
        manual: string;
      };
    };
  }

  interface PaletteOptions {
    charges?: {
      status?: {
        active?: string;
        inactive?: string;
        warning?: string;
      };
      backgrounds?: {
        light?: string;
        lighter?: string;
        panel?: string;
      };
      borders?: {
        light?: string;
        medium?: string;
        dark?: string;
      };
      chargeTypes?: {
        closed?: string;
        manual?: string;
      };
    };
  }
}

/**
 * Create theme extension with charges management specific colors
 *
 * NOTE: Use standard MUI palette for common colors:
 * - Primary colors: theme.palette.primary.main/dark/light (#2196F3)
 * - Success colors: theme.palette.success.main (#4CAF50)
 * - Error colors: theme.palette.error.main (#F44336)
 * - Warning colors: theme.palette.warning.main
 * - Info colors: theme.palette.info.main (#2196F3)
 * - Text colors: theme.palette.text.primary/secondary
 * - Background colors: theme.palette.background.paper/default
 * - Grey colors: theme.palette.grey[100-900]
 *
 * Only custom colors specific to Charges Management are defined here.
 */
export const chargesThemeExtension = {
  palette: {
    charges: {
      // Status colors
      status: {
        active: "#4CAF50", // Green for active status
        inactive: "#9e9e9e", // Grey for inactive
        warning: "#F44336", // Red for warnings
      },

      // Background colors
      backgrounds: {
        light: "#f5f5f5",
        lighter: "#f5f5f7",
        panel: "#f0f0f0",
      },

      // Border colors
      borders: {
        light: "#e8e8e8",
        medium: "#e0e0e0",
        dark: "#ccc",
      },

      // Custom colors for charge types
      chargeTypes: {
        closed: "#A52A2A", // Brown for closed
        manual: "#C96442", // Copper for manual
      },
    },
  },
};
